/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import TexturesManager from "App/utils/textures/textures_manager";
// @ts-ignore
import CrunchDecodeWorker from "App/workers/crunch_decode.worker";
import IScene from "js_interface/src/scene_interface";
// https://stackoverflow.com/questions/50210416/webpack-worker-loader-fails-to-compile-typescript-worker

export default
class CrunchDecodeWorkerManager {

    private sceneAPI: IScene;
    private texturesManager: TexturesManager;
    private worker: any = null;

    constructor(aSceneAPI: IScene, aTexturesManager: TexturesManager)
    {
        this.sceneAPI        = aSceneAPI;
        this.texturesManager = aTexturesManager;

        this.initWorker();
    }

    private initWorker() {
        //@ts-ignore
        this.worker = new CrunchDecodeWorker();
        this.createCrunchDecodeThreadListener();
    }

    public decodeTexture(aUID, aRequestedLevel, aTileIndex, aArrayBuffer)
    {
        let message = {
            type: 'decodeTexture',
            uid: aUID,
            requestedLevel: aRequestedLevel,
            tileIndex: aTileIndex,
            arrayBuffer: aArrayBuffer
        };

        this.worker.postMessage(message);
    }

    public createCrunchDecodeThreadListener()
    {
        this.worker.addEventListener('message', (e: MessageEvent) => {
            let message = e.data;
            switch (message.type) {
                case 'textureDecoded':
                    this.texturesManager.textureDecoded(message);
                    break;
                default:
            }
        }, false);
    }
}
